import {useEffect} from 'react'
import {useQuery} from 'react-query'
import {getFilters} from '../services'
import useFilters from '../../../hook/useFilters'
import {useAppSelector} from '../../../redux/useTypedSelector'

export const useGetReorderingFilters = (): any => {
  const {user} = useAppSelector((state) => state.auth)

  const isUserExist = user?.is_owner
    ? false
    : JSON.parse(localStorage.getItem('is_supplier') || 'false')

  const initialFilters = {
    primary_supplier: '',
    user: isUserExist ? user?.name : '',
    hide_discontinued: false,
  }

  const {filters, setSingleFilter, setMultipleFilters} = useFilters(initialFilters)

  const {
    data: response,
    refetch,
    isFetching,
  } = useQuery(`get-reordering-filters`, () => {
    return getFilters(filters)
  })

  useEffect(() => {
    refetch()
  }, [filters, refetch])

  if (!response?.['data']) {
    return []
  }

  const onResetDropdownFilters = () => {
    setMultipleFilters({
      primary_supplier: '',
      user: isUserExist ? user?.name : '',
    })
  }

  const handleUserChange = (user: string) => {
    if (!user) setSingleFilter('user', '')
    else setSingleFilter('user', user)
  }

  return {
   reorderFilters: response?.['data']?.['data'] || {
     primary_supplier: [],
   },
   isFetchingDropdownData: isFetching,
   refetchFilters: refetch,
   handleUserChange,
   onResetDropdownFilters,
 }
}
